import { render, staticRenderFns } from "./CurieTemperatureViz.vue?vue&type=template&id=7c915dea&scoped=true"
import script from "./CurieTemperatureViz.vue?vue&type=script&lang=js"
export * from "./CurieTemperatureViz.vue?vue&type=script&lang=js"
import style0 from "./CurieTemperatureViz.vue?vue&type=style&index=0&id=7c915dea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c915dea",
  null
  
)

export default component.exports